<!--  -->
<template>
  <div>
    <div class="optionbox">
      <div class="optiontext">渠道名称：</div>
      <el-input v-model="name" style="width:300px" placeholder="请输入内容" />
    </div>
    <!-- <div class="optionbox">
      <div class="optiontext">小说名称：</div>
      <el-tag v-if="xiaoshuoname">{{ xiaoshuoname }}</el-tag>
    </div>
    <div class="optionbox">
      <div class="optiontext">章节名称：</div>
      <el-tag v-if="xiaoshuoname">{{ zahngjiename }}</el-tag>
    </div> -->
    <div class="optionbox">
      <div class="optiontext">链接类型：</div>
      <el-radio-group v-model="linktyperadio">
        <el-radio :label="1">派单</el-radio>
        <el-radio :label="0">内推</el-radio>
      </el-radio-group>
    </div>
    <div class="optionbox">
      <div class="optiontext">二维码展示：</div>
      <div style="position: relative; display: inline-block;">
        <el-switch
          v-model="erweima"
          :width="60"
          active-color="#13ce66"
          inactive-color="rgb(191,191,191)"
          :active-value="1"
          :inactive-value="0"
        />
        <div
          v-if="erweima === 1"
          style="color: #fff;position: absolute;top: 2px;left: 7px;"
        >开启</div>
        <div
          v-else
          style="color: #fff;position: absolute;top: 2px;right: 7px;"
        >关闭</div>
      </div>
    </div>
    <div class="optionbox">
      <div class="optiontext">关注类型：</div>
      <el-radio-group v-model="followtyperadio">
        <el-radio :label="1">强制关注</el-radio>
        <el-radio :label="2">非强制关注</el-radio>
        <el-radio :label="3">常规关注</el-radio>
      </el-radio-group>
    </div>
    <div v-if="linktyperadio == 1">
      <div v-for="element,index in arr" :key="index" class="optionbox">
        <div class="optiontext">展示时间：</div>
        <el-date-picker
          v-model="element.timearr"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:410px"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="datavalue($event,index)"
        />
        <i class="el-icon-circle-plus" style="font-size:25px" @click="add(element,index)" />
        <i v-if="index!=0" class="el-icon-remove" style="font-size:25px" @click="jian(index)" />
      </div>
    </div>

    <el-button type="primary" @click="sumbit">确定</el-button>
  </div>
</template>

<script>
import { bookPlatformcreate } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    obj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      objquery: {},
      name: '',
      xiaoshuoname: '',
      zahngjiename: '',
      linktyperadio: 1,
      erweima: 1,
      followtyperadio: 1,
      timearr: [],
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      arr: [
        {
          timearr: []
        }
      ],
      chaunarr: []
    }
  },
  watch: {
    obj: {
      handler(newValue, oldValue) {
        // console.log('111', newValue)
        this.objquery = newValue
        this.name = newValue.bookname + '-' + newValue.chaptername
        this.xiaoshuoname = newValue.bookname
        this.zahngjiename = newValue.chaptername
      },
      deep: true
    }
  },
  created() {
    this.objquery = this.obj
  },
  mounted() {

  },
  methods: {
    datavalue(event, index) {
      console.log('val', event, index)
    },
    add(item, index) {
      console.log(item, index)
      // eslint-disable-next-line eqeqeq
      if (this.arr.length == 5) {
        this.$message.error('最多添加5个')
        return
      }
      this.arr.push({
        timearr: []
      })
      console.log(this.arr)
    },
    jian(index) {
      this.arr.splice(index, 1)
    },
    async sumbit() {
      console.log('this.objquery', this.objquery)
      if (this.objquery.platformvalue === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.objquery.bookid === null) {
        this.$message.error('请选择书籍')
        return
      }
      if (this.objquery.chapterid === null) {
        this.$message.error('请选择章节')
        return
      }
      if (this.name === '') {
        this.$message.error('请输入渠道名称')
        return
      }
      this.chaunarr = []
      for (let i = 0; i < this.arr.length; i++) {
        this.chaunarr.push({
          startTime: this.arr[i].timearr[0] ? this.arr[i].timearr[0] : '',
          endTime: this.arr[i].timearr[1] ? this.arr[i].timearr[1] : ''
        })
      }
      // eslint-disable-next-line eqeqeq
      if (this.linktyperadio == 1) {
        const data = await bookPlatformcreate({
          platform_id: this.objquery.platformvalue,
          template_data: {
            book_id: this.objquery.bookid,
            content_id: this.objquery.chapterid,
            book_name: this.objquery.bookname,
            chapter_name: this.objquery.chaptername,
            promotions_name: this.name,
            link_group: this.linktyperadio,
            qrcode_open_status: this.erweima,
            link_classify: this.followtyperadio,
            showtime: this.chaunarr
          }
        })
        this.$emit('close')
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        console.log('data', data)
      } else {
        const data = await bookPlatformcreate({
          platform_id: this.objquery.platformvalue,
          template_data: {
            book_id: this.objquery.bookid,
            content_id: this.objquery.chapterid,
            book_name: this.objquery.bookname,
            chapter_name: this.objquery.chaptername,
            promotions_name: this.name,
            link_group: this.linktyperadio,
            qrcode_open_status: this.erweima,
            link_classify: this.followtyperadio
          }
        })
        this.$emit('close')
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        console.log('data', data)
      }

      // console.log(' this.chaunarr', this.chaunarr)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.optionbox{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.optiontext{
  width: 100px;
  text-align: right;
}
.loltext{
  margin-left: 100px;
}
.demo-ruleForm /deep/ .el-input__inner{
  line-height: 1px !important;
}
/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.demo-ruleForm /deep/ input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
